import React from 'react';
import { Link } from 'gatsby';

import Arrow from './arrow.svg';

export class ArrowLink extends React.Component {
  constructor (props) {
    super(props);
    this.state = {};
  }

  onClick = () => {
    this.props.onClick && this.props.onClick();
  }

  render () {
    return this.props.to ? (
      <Link to={this.props.to} className="arrow-link typo-body" onClick={this.onClick}>
        <div>{ this.props.children }</div>
        <img className="arrow-link__arrow" src={Arrow} alt="->" />
      </Link>
    )
    : (
      <div className="arrow-link typo-body" onClick={this.onClick}>
        <div>{ this.props.children }</div>
        <img className="arrow-link__arrow" src={Arrow} alt="->" />
      </div>
    );
  }
}
